module.exports = __webpack_public_path__ + "img/hiringcomparison.c95e65bb.svg";